import { render, staticRenderFns } from "./ThemeDetail.vue?vue&type=template&id=13bb5415&scoped=true&"
import script from "./ThemeDetail.vue?vue&type=script&lang=js&"
export * from "./ThemeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bb5415",
  null
  
)

export default component.exports